//#region Imports
import React, { useState, useEffect } from "react";
import sharedDatas from "../../businessLogic/sharedDatas";
import { useNavigate } from "react-router-dom";

//oneFront SDK
import {
  useSnackbar,
  useMutation,
  useTranslation,
} from "@1f/react-sdk";

import VaporPage from "@vapor/react-custom/VaporPage";

//Vapor Components
import Grid from "@vapor/react-material/Grid";
import Stack from "@vapor/react-material/Stack";
import IconButton from "@vapor/react-material/IconButton";
import Button from "@vapor/react-material/Button";
import Alert from "@vapor/react-material/Alert";

import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

import {
  DataGridPro,
  GridToolbar,
  itIT,
} from "@mui/x-data-grid-pro";

//Icons
import {
  ArrowForward as DetailIcon,
  Add as AddIcon,
  DeleteOutlineOutlined as DeleteIcon,
} from "@mui/icons-material";

//Custom components
import { Loading } from "../../components/Loading";
import { NotAuth } from "../../components/NotAuth";
import { NoData } from "../../components/NoData";
import { ModalDelete } from "../../components/ModalDelete";

import {
  pathAziendaHome,
  pathAziendaAdd,
  pathHome,
} from "../../businessLogic/constants/path";
import { setLocalStorageSelectedAzienda } from "../../businessLogic/helpers/storageHelpers";

import {
  query_fascicolo_byAzienda_count,
} from "../../businessLogic/query/fascicoloQueris";

import {
  query_autoValutazione_byAzienda_count,
} from "../../businessLogic/query/autovalutazioneQueries";

import { mutation_add_lastActivity_byUserId, mutation_delete_lastActivity } from "../../businessLogic/mutations/lastActivityMutations";
import { mutation_read_metering_consumption } from "../../businessLogic/mutations/meteringMutations";
import { LogApi } from "../../businessLogic/api/logApi";

//Other components
import postal from "postal";
import { AziendaApi } from "../../businessLogic/api/aziendaApi";
import { isTenantReadOnly } from "../../businessLogic/helpers/licenseHelpers";
//#endregion

export const AziendaHome = ({ basePath }) => {
  const navigate = useNavigate();  
  const tenantId = sharedDatas.getPropertyByName("tenantId");
  const tenant = sharedDatas.getPropertyByName("tenantModel");
  const aziendaId = sharedDatas.getPropertyByName("aziendaId");
  const loggedUserId = sharedDatas.getPropertyByName("userId");
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  
  //Api
  const logApi = LogApi();
  const aziendaApi = AziendaApi()

  if (
    loggedUserId === "" ||
    tenantId === "" ||
    aziendaId === 0
  ) {
    navigate(pathHome);
  } 

  //#region Mutation
  const apiAddLastActivity = useMutation(mutation_add_lastActivity_byUserId, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiDeleteLastActivity = useMutation(mutation_delete_lastActivity, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiCountFascByAzienda = useMutation(query_fascicolo_byAzienda_count, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiCountAutoByAzienda = useMutation(
    query_autoValutazione_byAzienda_count,
    { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiReadMeteringConsumption = useMutation(
    mutation_read_metering_consumption,
    { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  //#endregion
  
  //#region UseStates
  const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
  const [isDataLoaded, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
  const [isUserOwner] = useState(
    sharedDatas.getPropertyByName("userModel") !== null
      ? sharedDatas.getPropertyByName("userModel").type === "OWNER"
      : false
  );
  const [aziendeList, setAziendeList] = useState([]); //Contiene le aziende

  //DataGrid
  const [, setDataItems] = useState([]); //Contiene i records
  const [dataColumns, setDataColumns] = useState([]); //Contiene le columns
  const [dataRows, setDataRows] = useState([]); //Contiene le rows

  const [showDeleteModal, setShowDeleteModal] = useState(false); //Modal per la conferma di eliminazione di un record
  const [idToPerform, setIdToPerform] = useState(0); //Contiene l'id del record da eliminare
  const [showExtraSoglia, setShowExtraSoglia] = useState(false);
  const [usedMessage, setUsedMessage] = useState("");
  //#endregion

  useEffect(() => {
    loadDatas();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);

  async function loadDatas() {
    try {
      if (!isUserOwner) return;
      if (
        sharedDatas.getPropertyByName("tenantId") === "" ||
        sharedDatas.getPropertyByName("tenantModel") === null ||
        sharedDatas.getPropertyByName("aziendaId") === 0 ||
        sharedDatas.getPropertyByName("aziendaModelList") === null ||
        sharedDatas.getPropertyByName("userId") === "" ||
        sharedDatas.getPropertyByName("userModel") === null
      ) {
        navigate("/");
      } else {
        setBackDropOpen(true);

        if (!isDataLoaded && loggedUserId !== "" && tenantId !== "") {
          //Last Activity
          await apiDeleteLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            userId: loggedUserId,
          });
          await apiAddLastActivity.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
            path: pathAziendaHome,
            entityId: "",
            entityName: "",
          });

          /**************************************/
          //Recupero i consumi del metering
          let availableSlots = 0;
          let usedSlots = 0;
          let remainingSlots = 0;

          const addConsumptionResp = await apiReadMeteringConsumption.fetch({
            tenantId: tenantId,
          });
          availableSlots =
            addConsumptionResp.data.data.readMeteringConsumption.availableSlots;
          usedSlots =
            addConsumptionResp.data.data.readMeteringConsumption.usedSlots;
          remainingSlots =
            addConsumptionResp.data.data.readMeteringConsumption.remainingSlots;

          setShowExtraSoglia(remainingSlots <= 0);
          setUsedMessage("Utilizzati " + usedSlots + " su " + availableSlots);

          /**************************************/
          //Carico le aziende
          setDataColumns([
            { field: "id", headerName: "Id", flex: 0.2, type: "number" },
            {
              field: "cf",
              headerName: "Codice Fiscale",
              flex: 0.2,
              editable: false,
            },
            { field: "pIva", headerName: "P. Iva", flex: 0.2, editable: false },
            {
              field: "denominazione",
              headerName: "Denominazione",
              flex: 1,
              editable: false,
            },
            {
              field: "actions",
              headerName: "",
              flex: 0.2,
              filterable: false,
              renderCell: (params) => renderDetailsButton(params.row),
            },
          ]);

          const allAziendaResponse = await aziendaApi.GetAllAziende(tenantId);          
          const arrItems = [];
          for (let i = 0; i < allAziendaResponse.length; i++) {
            const item = allAziendaResponse[i];
            const itemModel = {
              id: item.id,
              cf: item.cf,
              pIva: item.pIva,
              denominazione: item.denominazione,
            };
            arrItems.push(itemModel);
          }

          setAziendeList(arrItems);
          setDataItems(arrItems);
          setDataRows(arrItems);
        }
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "loadDatas", "AziendaHome");      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
      setIsDataLoaded(true);
    }
  }
  //DataGrid
  //Grid Button Detail
  const renderDetailsButton = (item) => {
    return (
      <Stack direction='row' spacing={0}>
        {isUserOwner && !isTenantReadOnly(tenant) &&
        (tenant.identifier !== item.cf || tenant.vatNumber !== item.pIva) ? (
          <IconButton
            color='error'
            onClick={(e) => handleGridBtnDeleteClick(e, item)}
          >
            <DeleteIcon />
          </IconButton>
        ) : null}
        {isUserOwner ? (
          <IconButton
            color='primary'
            onClick={(e) => handleGridBtnDetailClick(e, item)}
          >
            <DetailIcon />
          </IconButton>
        ) : null}
      </Stack>
    );
  };

  //#region Handlers
  //Add New Button
  const handleAddNew = () => {
    if (!isUserOwner || isTenantReadOnly(sharedDatas.getPropertyByName("tenantModel"))) return;
    setLocalStorageSelectedAzienda(0);
    navigate(pathAziendaAdd);
  };
  const handleGridBtnDetailClick = (event, item) => {
    event.stopPropagation();
    if (!isUserOwner) return;
    setLocalStorageSelectedAzienda(item.id);
    navigate("/azienda/manage");
  };
  const handleGridBtnDeleteClick = (event, item) => {
    event.stopPropagation();
    if (!isUserOwner || isTenantReadOnly(sharedDatas.getPropertyByName("tenantModel"))) return;
    setIdToPerform(item.id);
    setShowDeleteModal(true);
  };
  //#endregion

  //#region Modal Delete
  const handleModalDeleteClose = () => {
    setIdToPerform(0);
    setShowDeleteModal(false);
  };
  const handleModalDeleteOkClick = async () => {
    if (!isUserOwner || isTenantReadOnly(sharedDatas.getPropertyByName("tenantModel"))) return;
    try {
      if (idToPerform > 0) {
        setBackDropOpen(true);

        const countFascicoli = await apiCountFascByAzienda.fetch({
          tenantId: tenantId,
          aziendaId: idToPerform,
        });
        const countAutoval = await apiCountAutoByAzienda.fetch({
          tenantId: tenantId,
          aziendaId: idToPerform,
        });

        if (
          countFascicoli.data.data.fascicolo_aggregate.aggregate.count <= 0 &&
          countAutoval.data.data.autovalutazione_aggregate.aggregate.count <= 0
        ) {
          if (!isUserOwner || isTenantReadOnly(sharedDatas.getPropertyByName("tenantModel"))) {
            setBackDropOpen(false);
            setShowDeleteModal(false);
            return;
          }
          let aziendaDeleteResopnse = await aziendaApi.DeleteAzienda(idToPerform,tenantId);
          if(aziendaDeleteResopnse){
            //Aggiorno la lista delle aziende in memoria
            const aziende = Object.assign([], aziendeList);
            const newArr = aziende.filter(
              (item) => item.id !== idToPerform
            );
            sharedDatas.setPropertyValue("aziendaModelList", newArr);

            //Invio una notifica tramite pub/sub interno
            postal.publish({
              channel: "azienda",
              topic: "azienda.update",
              data: {
                aziende: newArr,
              },
            });

            //Se ho eliminato l'azienda attualmente selezionata, switcho alla prima disponibile
            if (parseInt(sharedDatas.getPropertyByName("aziendaId")) === idToPerform) {
              sharedDatas.setPropertyValue("aziendaId",parseInt(newArr[0].id));
            }

            //Resetto le variabili
            setIdToPerform(0);
            setShowDeleteModal(false);
            setIsDataLoaded(false);
            enqueueSnackbar(t("message.success"), { variant: "success" });
          }
        } else {
            setIdToPerform(0);
            setShowDeleteModal(false);
            enqueueSnackbar(
              "Non è possibile eliminare questo Soggetto in quanto ci sono dati collegati ad esso",
              { variant: "warning" }
            );
          }
          setBackDropOpen(false);
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleModalDeleteOkClick", "AziendaHome");         
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  //#endregion

  //#region Return Grphics
  return (
    <VaporPage
      title={t("nav.aziende")}
      headerRight={
        <Button
          variant='text'
          size='medium'
          endIcon={<AddIcon />}
          color='primary'
          onClick={handleAddNew}
          disabled={!isUserOwner || isTenantReadOnly(tenant)}
          sx={{ mr: 2 }}
        >
          {t("actions.nuovo")}
        </Button>
      }
      headerLeft={
        <ExtendedTypography variant='subtitle2' sx={{ ml: 3 }}>
          {usedMessage}
        </ExtendedTypography>
      }
    >
      <Loading open={backDropOpen} />

      {isDataLoaded && !isUserOwner ? <NotAuth /> : null}

      {showDeleteModal ? (
        <ModalDelete
          show={showDeleteModal}
          onClose={handleModalDeleteClose}
          onOk={handleModalDeleteOkClick}
          deleteMessage={t("modal.deleteDesc")}
        ></ModalDelete>
      ) : null}

      {isDataLoaded && isUserOwner ? (
        <VaporPage.Section>
          <Grid container>
            {showExtraSoglia ? (
              <Grid item xs={12}>
                <Alert variant='outlined' severity='warning'>
                  {t("azienda.aziendaHome.alert")}
                </Alert>
              </Grid>
            ) : null}
            <Grid item xs={12} sx={{ width: "100%", mt: 3 }}>
              {dataRows.length > 0 ? (
                <DataGridPro
                  rows={dataRows}
                  columns={dataColumns}
                  autoHeight={true}
                  slots={{ toolbar: GridToolbar }}
                  pageSizeOptions={[25, 50, 100]}
                  localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                  }
                  pagination
                  disableRowSelectionOnClick
                  onRowClick={(item, e) =>
                    handleGridBtnDetailClick(e, item.row)
                  }
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        id: false,
                      },
                    },
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  slotProps={{
                    toolbar: { printOptions: { disableToolbarButton: true } },
                  }}
                />
              ) : (
                <NoData />
              )}
            </Grid>
          </Grid>
        </VaporPage.Section>
      ) : null}
    </VaporPage>
  );
  //#endregion
};
